
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingHeroSection = () => {
  return (
    <section className="relative min-h-[50vh] overflow-hidden">
      {/* Background skeleton */}
      <div className="absolute inset-0 w-full h-full">
        <Skeleton className="w-full h-full" />
      </div>
      
      {/* Content skeleton */}
      <div className="relative z-10">
        <div className="flex flex-col items-center justify-center pt-8 pb-0 mb-0">
          {/* Profile image skeleton */}
          <div className="flex flex-col items-center pt-6 relative z-20">
            <Skeleton className="w-28 h-28 md:w-36 md:h-36 rounded-full mb-4" />
            {/* Name skeleton */}
            <Skeleton className="h-8 w-64 mb-2" />
            {/* Date skeleton */}
            <Skeleton className="h-5 w-36 mb-4" />
          </div>
          
          {/* Introduction skeleton */}
          <div className="w-full max-w-3xl mx-auto px-4 mb-8 mt-4">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <Skeleton className="h-4 w-full mb-2" />
              <Skeleton className="h-4 w-11/12 mb-2" />
              <Skeleton className="h-4 w-10/12 mb-2" />
              <Skeleton className="h-4 w-9/12" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
